'use client'

import { Linkedin, Facebook, Instagram, Twitter, Youtube } from "lucide-react"


interface SocialAccountsProps {
  socialAccounts?: {
    linkedin?: string
    facebook?: string
    instagram?: string
    twitter?: string
    youtube?: string
  }
  size?: 'md' | 'lg'
  className?: string
  align?: 'left' | 'center' | 'right'
}

export function SocialAccounts({ socialAccounts, size = 'md', className = "", align = 'center' }: SocialAccountsProps) {
  if (!socialAccounts || Object.keys(socialAccounts).length === 0) {
    return null
  }

  const iconSize = size === 'md' ? 'h-5 w-5' : 'h-7 w-7'

  const alignmentClasses = {
    left: 'justify-start',
    center: 'justify-center',
    right: 'justify-end'
  }

  const socialItems = [
    { label: 'LinkedIn', url: socialAccounts.linkedin, icon: Linkedin },
    { label: 'Facebook', url: socialAccounts.facebook, icon: Facebook },
    { label: 'Instagram', url: socialAccounts.instagram, icon: Instagram },
    { label: 'Twitter', url: socialAccounts.twitter, icon: Twitter },
    { label: 'Youtube', url: socialAccounts.youtube, icon: Youtube },
  ]

  return (
    <div className={`flex ${alignmentClasses[align]} gap-2 ${className}`}>
      {socialItems.map((item) => {
        if (!item.url) return null
        
        return (
          <a 
            key={item.label}
            href={item.url} 
            target="_blank" 
            rel="noopener noreferrer"
            className="text-teal-800 hover:text-white hover:bg-teal-900 p-2 rounded-md transition-colors"
            onClick={(e) => e.stopPropagation()}
          >
            {item.label === "LinkedIn" && <Linkedin className={iconSize} />}
            {item.label === "Facebook" && <Facebook className={iconSize} />}
            {item.label === "Instagram" && <Instagram className={iconSize} />}
            {item.label === "Twitter" && <Twitter className={iconSize} />}
            {item.label === "Youtube" && <Youtube className={iconSize} />}
          </a>
        )
      })}
    </div>
  )
} 
